var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    _vm._l(_vm.order.purchases, function(purchase, index) {
      return _c("div", [
        _c("div", { staticClass: "row no-gutters" }, [
          _c("div", { staticClass: "col-6" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm._f("multiLangName")(purchase.service)) +
                "\n        "
            ),
            purchase.purchase_qty
              ? _c("span", [
                  _vm._v(
                    "\n          (" +
                      _vm._s(_vm.$t("message.my_reservations.label_qty")) +
                      ": " +
                      _vm._s(_vm._f("prettyNumber")(purchase.purchase_qty)) +
                      ")\n        "
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-6 text-right" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm._f("currency")(purchase.total_price)) +
                "\n      "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row no-gutters mt-1" }, [
          _c("div", { staticClass: "col-6" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$t("message.my_reservations.summary_total.service_vat")
                ) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-6 text-right" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm._f("currency")(purchase.service_vat)) +
                "\n      "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row no-gutters mt-3" }, [
          _c("div", { staticClass: "col-6" }, [
            _c("label", [
              _vm._v(
                _vm._s(_vm.$t("message.my_reservations.summary_total.total"))
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-6 text-right" }, [
            _c("label", [
              _vm._v(_vm._s(_vm._f("currency")(purchase.total_price_with_vat)))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row no-gutters mt-1" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("span", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$options.filters.orderPaymentData(purchase.payment_data)
                )
              }
            }),
            _vm._v(" "),
            !purchase.paid_status
              ? _c("span", { staticClass: "d-inline-block text-orange" }, [
                  _vm._v(
                    "\n          (" +
                      _vm._s(_vm.$t("message.all_pending")) +
                      ")\n        "
                  )
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row no-gutters mt-1 text-secondary" }, [
          _c("div", { staticClass: "col-6" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("message.my_reservations.created_at")) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-6 text-right" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm._f("prettyDate")(purchase.created_at)) +
                "\n      "
            )
          ])
        ]),
        _vm._v(" "),
        purchase.paid_status && purchase.paid_at
          ? _c("div", { staticClass: "row no-gutters mt-1 text-secondary" }, [
              _c("div", { staticClass: "col-6" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("message.my_reservations.paid_at")) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6 text-right" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm._f("prettyDate")(purchase.paid_at)) +
                    "\n      "
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.order.purchases.length > 1 && index + 1 < _vm.order.purchases.length
          ? _c("hr")
          : _vm._e()
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5468d947", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5468d947","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/components/OrderPurchase.vue
// module id = 1772
// module chunks = 0